@if (data$ | async; as data) {
  <app-alerts />

  <app-warehouse-product-form
    [disabledControls]="disabledControls"
    [data]="data"
    (submitSuccessEvent)="handleSubmitSuccessEvent($event)" />
} @else {
  <app-spinner-filled />
}
